import { createSSRApp, type App as VueApp } from 'vue'
import App from './App.vue'
import { setupStore } from '@/store'

import '@/styles/global.scss'

export function createApp(): { app: VueApp } {
  const app = createSSRApp(App)

  setupStore(app)

  return {
    app,
  }
}
